import { changeB2C } from '@/apis/login'
import store, { isD2C, useCustomerShopId, useToken } from '@/store'
import { ref } from 'vue'

export enum AuthStatusEnum{
  hidden='',
  beforeBind='1',
  binding='2',
  bindSuccess='3'
}
export const authStatus = ref('')

export const authQuery = ref<any>(null)

/** auth跳转后流程图 */
const fromPublicApp = async (query:any) => {
  // const customerShopId = localStorage.customerShopIdForBindShopify
  // if (customerShopId) {
  //   delete localStorage.customerShopIdForBindShopify
  // }

  const token = useToken()
  const { customerShopId } = useCustomerShopId()
  if (query.token) {
    if (query.customerShopId !== customerShopId) {
      store.commit('route/curShop', query.customerShopId)
    }
    // 如果是已授权账号
    if (query.token !== token) {
      // 不相等则更新当前token，重新登录
      await store.dispatch('route/changeToken', query.token)
      //
      location.replace(location.href.replace(/\?.*$/, ''))
    } else {
      location.replace(location.href.replace(/\?.*$/, ''))
    }
  } else {
    // 如果传了shopId直接调用接口
    authQuery.value = { ...query }
    // 否则是初次从shopfiy进入ckb应用
    if (token) {
      // 如果已登录
      const isd2c = isD2C()
      if (isd2c) {
        // 如果已登录2c账号，绑定店铺
        authStatus.value = AuthStatusEnum.binding
      } else {
        // 否则切换至2c账号，刷新
        changeB2C().then((res) => {
          store.dispatch('route/changeToken', res.data.token)
          location.reload()
        })
      }
    } else {
      // 否则跳转去注册或登录页
      authStatus.value = AuthStatusEnum.beforeBind
    }
  }
  console.log(query)
}

fromPublicApp.APP = {
  cafe24: '6'
} as any
export default fromPublicApp

// 订阅模式promise版
export const handleEmit = <T>(prev?: Promise<T> | T) => {
  let emit!: () => void
  const pending = <U>(res: Promise<U> | U) => new Promise<U>((resolve, reject) => {
    emit = resolve.bind(null, res)
  })
  const promise = pending(prev)
  return [promise, emit] as const
}
